import {
  CheckCircleOutlined, EditOutlined, StopOutlined,
  CopyOutlined, EyeOutlined, LockOutlined,
} from "@ant-design/icons";
import { PageHeader, Popconfirm, Tag, Tooltip, message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ButtonItem, SegmentedItem, TableItemDinamico } from "../../../Components/Items";
import moment from "moment";
import "moment/locale/es";
import AgregarTabla from "./AgregarTabla/AgregarTabla";
import EditarTabla from "./EditarTabla/EditarTabla";
import VerTabla from "./VerTabla/VerTabla";

moment.locale("es");

class Tablas extends Component {
  tableRef = null;
  state = {
    todasTablas: [],
    loading: false,
    valor: 1,
    modalAgregarTabla: false,
    modalEditarTabla: false,
    modalEditarTablaId: null,
    modalVerTabla: false,
    modalVerTablaId: null,
  };

  consultarTablas(params) {
    this.setState({ loading: true });
    axios
      .post("tablas/selectTodasTablas", { empresaId: this.props.empresaId, ...params }, { headers: this.props.headersToken })
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success !== 2) {
          this.setState({ todasTablas: [] });
        } else {
          this.setState({ todasTablas: res.data.data, totalRecords: res.data.totalRecords || 0 });
        }
      });
  }

  duplicarTabla(tablaId) {
    this.setState({ loading: true });
    axios
      .post("tablas/duplicarTabla", { tablaId, empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Tabla duplicada exitosamente");
        } else {
          message.error("No se pudo duplicar la tabla");
        }
        if (this.tableRef) this.tableRef.updateExternalFilters({ valor: this.state.valor });
      });
  }

  deshabilitarTabla(tablaId) {
    axios
      .post("tablas/deshabilitarTabla", { tablaId, empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.success === 2) message.success("Tabla deshabilitada");
        else message.error("No se pudo deshabilitar");
        if (this.tableRef) this.tableRef.updateExternalFilters({ valor: this.state.valor });
      });
  }

  habilitarTabla(tablaId) {
    axios
      .post("tablas/habilitarTabla", { tablaId, empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.success === 2) message.success("Tabla habilitada");
        else message.error("No se pudo habilitar");
        if (this.tableRef) this.tableRef.updateExternalFilters({ valor: this.state.valor });
      });
  }

  agregarTabla() { this.setState({ modalAgregarTabla: true }); }
  cerrarAgregarTabla() {
    this.setState({ modalAgregarTabla: false });
    this.tableRef.updateExternalFilters({ valor: this.state.valor });
  }

  editarTabla(id) { this.setState({ modalEditarTabla: true, modalEditarTablaId: id }); }
  cerrarEditarTabla() {
    this.setState({ modalEditarTabla: false });
    this.tableRef.updateExternalFilters({ valor: this.state.valor });
  }

  verTabla(id) { this.setState({ modalVerTabla: true, modalVerTablaId: id }); }
  cerrarVerTabla() { this.setState({ modalVerTabla: false, modalVerTablaId: null }); }

  render() {
    const columns = [
      {
        title: "Número",
        dataIndex: "numero",
        key: "numero",
        buscar: "serieNumero",
        render: (value, record) => `${record.serie} - ${record.numero}`,
        width: "6%",
      },
      {
        title: "Nombre",
        dataIndex: "nombre",
        key: "nombre",
        buscar: "nombre",
        width: "18%",
        render: (value, record) => (
          <span>
            {value}
            {record.esSistema && (
              <Tooltip title="Tabla de sistema — solo lectura">
                <LockOutlined style={{ marginLeft: 6, color: "#faad14" }} />
              </Tooltip>
            )}
          </span>
        ),
      },
      {
        title: "Nombre Fórmula",
        dataIndex: "nombreFormula",
        key: "nombreFormula",
        buscar: "nombreFormula",
        width: "12%",
        render: (value) => value
          ? <Tag style={{ fontFamily: "monospace" }}>{value}</Tag>
          : "—",
      },
      {
        title: "Descripción",
        dataIndex: "descripcion",
        key: "descripcion",
        buscar: "descripcion",
        width: "20%",
      },
      {
        title: "Vigencia",
        key: "vigencia",
        width: "13%",
        render: (_, record) => {
          const ini = record.fechaInicioVigencia ? moment(record.fechaInicioVigencia).format("DD/MMM/YYYY") : null;
          const fin = record.fechaFinVigencia ? moment(record.fechaFinVigencia).format("DD/MMM/YYYY") : null;
          if (!ini && !fin) return "—";
          return `${ini || "?"} — ${fin || "?"}`;
        },
      },
      {
        title: "Col / Filas",
        key: "dimensiones",
        width: "7%",
        render: (_, record) => (
          <span>
            <Tag>{record.totalColumnas}c</Tag>
            <Tag>{record.totalFilas}f</Tag>
          </span>
        ),
      },
      {
        title: "Origen",
        dataIndex: "esSistema",
        key: "esSistema",
        width: "7%",
        render: (value) => value ? <Tag color="gold">Sistema</Tag> : <Tag color="blue">Empresa</Tag>,
      },
      {
        title: "Estado",
        dataIndex: "estado",
        key: "estado",
        width: "7%",
        render: (value, record) => {
          if (record.esSistema) return <Tag color="gold">Sistema</Tag>;
          if (value === 1) return <Tag color="green">Activo</Tag>;
          if (value === 2) return <Tag color="orange">Deshabilitado</Tag>;
          return "—";
        },
      },
      {
        title: "Acción",
        key: "accion",
        width: "12%",
        render: (_, record) => {
          const buttons = [];

          buttons.push(
            <Tooltip key={`ver-${record._id}`} title="Ver Tabla" placement="top"
              overlayInnerStyle={{ fontSize: "10px", padding: "1px 5px", minHeight: "auto" }}>
              <ButtonItem type="default" size="small" icon={<EyeOutlined />}
                onClick={() => this.verTabla(record._id)} />
            </Tooltip>
          );

          buttons.push(
            <Popconfirm key={`duplicar-${record._id}`} title="¿Duplicar esta tabla para tu empresa?"
              onConfirm={() => this.duplicarTabla(record._id)} okText="Sí" cancelText="No">
              <Tooltip title="Duplicar" placement="top"
                overlayInnerStyle={{ fontSize: "10px", padding: "1px 5px", minHeight: "auto" }}>
                <ButtonItem type="default" size="small" icon={<CopyOutlined />} />
              </Tooltip>
            </Popconfirm>
          );

          if (!record.esSistema) {
            buttons.push(
              <Tooltip key={`editar-${record._id}`} title="Editar Tabla" placement="top"
                overlayInnerStyle={{ fontSize: "10px", padding: "1px 5px", minHeight: "auto" }}>
                <ButtonItem type="default" size="small" cyan icon={<EditOutlined />}
                  onClick={() => this.editarTabla(record._id)} />
              </Tooltip>
            );

            if (record.estado === 1) {
              buttons.push(
                <Popconfirm key={`deshabilitar-${record._id}`} title="¿Deshabilitar esta tabla?"
                  onConfirm={() => this.deshabilitarTabla(record._id)} okText="Sí" cancelText="No">
                  <Tooltip title="Deshabilitar" placement="top"
                    overlayInnerStyle={{ fontSize: "10px", padding: "1px 5px", minHeight: "auto" }}>
                    <ButtonItem type="default" size="small" lima icon={<CheckCircleOutlined />} />
                  </Tooltip>
                </Popconfirm>
              );
            } else {
              buttons.push(
                <Popconfirm key={`habilitar-${record._id}`} title="¿Habilitar esta tabla?"
                  onConfirm={() => this.habilitarTabla(record._id)} okText="Sí" cancelText="No">
                  <Tooltip title="Habilitar" placement="top"
                    overlayInnerStyle={{ fontSize: "10px", padding: "1px 5px", minHeight: "auto" }}>
                    <ButtonItem type="default" size="small" rojo icon={<StopOutlined />} />
                  </Tooltip>
                </Popconfirm>
              );
            }
          }

          return <div className="acciones-container">{buttons}</div>;
        },
      },
    ];

    return (
      <>
        <PageHeader
          title="Tablas"
          style={{ border: "1px solid rgb(235, 237, 240)", backgroundColor: "white", marginBottom: 10 }}
          extra={
            <>
              {window.innerWidth > 1000 && (
                <SegmentedItem
                  options={[{ label: "Vigente", value: 1 }, { label: "Deshabilitado", value: 2 }, { label: "Todos", value: 3 }]}
                  onChange={(value) => {
                    if (this.tableRef) this.tableRef.updateExternalFilters({ valor: value, textoFiltro: this.state.textoFiltro });
                    this.setState({ valor: value });
                  }}
                  value={this.state.valor}
                />
              )}
              <ButtonItem type="primary" key="agregarTabla" onClick={this.agregarTabla.bind(this)}>
                Agregar Tabla
              </ButtonItem>
            </>
          }
        />
        <TableItemDinamico
          ref={(ref) => (this.tableRef = ref)}
          onRef={(ref) => (this.tableRef = ref)}
          totalRecords={this.state.totalRecords}
          loading={this.state.loading}
          onFetchData={this.consultarTablas.bind(this)}
          anadirValorFiltro={this.state.valor}
          size="small"
          onlyMineFilter
          dataSource={this.state.todasTablas}
          columns={columns}
          scroll={{ x: "max-content" }}
          filterStorageKey={"tablas" + this.props.empresaId}
          onRow={(record) => ({
            onDoubleClick: () => record.esSistema ? this.verTabla(record._id) : this.editarTabla(record._id),
          })}
          setValor={(valor) => this.setState({ valor })}
          valorDefault={1}
        />
        <AgregarTabla
          visible={this.state.modalAgregarTabla}
          cerrarAgregarTabla={this.cerrarAgregarTabla.bind(this)}
        />
        <EditarTabla
          visible={this.state.modalEditarTabla}
          tablaId={this.state.modalEditarTablaId}
          cerrarEditarTabla={this.cerrarEditarTabla.bind(this)}
        />
        <VerTabla
          visible={this.state.modalVerTabla}
          tablaId={this.state.modalVerTablaId}
          cerrarVerTabla={this.cerrarVerTabla.bind(this)}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(Tablas);